export const SMS_TPL_ITEMS = [
  {
    topic: 'VERIFY',
    titleKey: 'system.text_295',
    cnKey: 'verifiyCode',
    enKey: 'verifiyCodeEn',
    cnChannel: 'verifiyCodeChannel',
    enChannel: 'verifiyCodeEnChannel',
    detailCn: 'verifiyCode',
    detailEn: 'verifiyCodeUn',
  },
  {
    topic: 'MONITOR',
    titleKey: 'system.alert_tpl',
    cnKey: 'alertsCode',
    enKey: 'alertsCodeEn',
    cnChannel: 'alertsCodeChannel',
    enChannel: 'alertsCodeEnChannel',
    detailCn: 'alertsCode',
    detailEn: 'alertsCodeUn',
  },
  {
    topic: 'USER_LOGIN_EXCEPTION',
    titleKey: 'system.error_login_tpl',
    cnKey: 'errorCode',
    enKey: 'errorCodeEn',
    cnChannel: 'errorCodeChannel',
    enChannel: 'errorCodeEnChannel',
    detailCn: 'errorCode',
    detailEn: 'errorCodeUn',
  },
]

export const SMS_TPL_VALUE_KEYS = SMS_TPL_ITEMS.reduce((ret, item) => {
  return ret.concat([item.cnKey, item.enKey, item.cnChannel, item.enChannel])
}, [])

export function channelCodeContent (code, channel) {
  const c = (code || '').trim()
  if (!c) return ''
  const ch = (channel || '').trim()
  return ch ? `${ch}/${c}` : c
}

export function parseChannelCode (content) {
  if (!content) return { code: '', channel: '' }
  const idx = `${content}`.indexOf('/')
  if (idx > 0) {
    return { channel: content.slice(0, idx), code: content.slice(idx + 1) }
  }
  return { code: content, channel: '' }
}

export function buildSmsTemplates (values = {}) {
  const tpls = []
  SMS_TPL_ITEMS.forEach(item => {
    const cn = channelCodeContent(values[item.cnKey], values[item.cnChannel])
    if (cn) {
      tpls.push({ lang: 'cn', topic: item.topic, content: cn })
    }
    const en = channelCodeContent(values[item.enKey], values[item.enChannel])
    if (en) {
      tpls.push({ lang: 'en', topic: item.topic, content: en })
    }
  })
  return tpls.map(v => {
    return {
      ...v,
      contact_type: 'mobile',
      template_type: 'remote',
    }
  })
}

export function omitSmsTplValues (content = {}) {
  const rest = { ...content }
  SMS_TPL_VALUE_KEYS.forEach(key => {
    delete rest[key]
  })
  return rest
}

export function parseSmsTplInfo (data = []) {
  const info = {}
  data.forEach(v => {
    const item = SMS_TPL_ITEMS.find(i => i.topic === v.topic)
    if (!item) return
    if (v.lang === 'cn') {
      info[item.detailCn] = v.content
    }
    if (v.lang === 'en') {
      info[item.detailEn] = v.content
    }
  })
  return info
}

export function parseSmsTplFormValues (data = [], isHuawei = false) {
  const values = {}
  data.forEach(v => {
    const item = SMS_TPL_ITEMS.find(i => i.topic === v.topic)
    if (!item) return
    const parsed = isHuawei ? parseChannelCode(v.content) : { code: v.content, channel: '' }
    if (v.lang === 'cn') {
      values[item.cnKey] = parsed.code
      values[item.cnChannel] = parsed.channel
    }
    if (v.lang === 'en') {
      values[item.enKey] = parsed.code
      values[item.enChannel] = parsed.channel
    }
  })
  return values
}
